export const STATUS_SETTINGS_INFORMATION = 'STATUS_SETTINGS_INFORMATION';
export const TAG_SETTINGS_INFORMATION = 'TAG_SETTINGS_INFORMATION';
export const EVENT_DATA_SETTINGS_INFORMATION = 'EVENT_DATA_SETTINGS_INFORMATION';
export const EVENT_TEMPLATE_SETTINGS_INFORMATION = 'EVENT_TEMPLATE_SETTINGS_INFORMATION';

export const USER_ONBOARDING = 'USER_ONBOARDING';
export const ADMIN_ONBOARDING = 'ADMIN_ONBOARDING';
